import { GRAPHQL_ENDPOINT } from "../apollo/client";
import { setAuthToken } from "../apollo/auth";
import React, { useEffect, useState } from 'react';
import { TextInput, Button } from '@carbon/react';
import { createSHA256Hash } from "../Utils/cryptoUtils";


export default function AuthPage() {
    const [sessionMessage, setSessionMessage] = useState(null);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const expired = localStorage.getItem('sessionExpired');
        if (expired) {
            setSessionMessage('Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.');
            // Remove the flag so message only shows once
            localStorage.removeItem('sessionExpired');
        }
    }, []);

    async function login(username, password) {
        try {
            const response = await fetch(GRAPHQL_ENDPOINT + '/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: username,
                    password: createSHA256Hash(password),
                }),
            });

            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('Benutzername oder Passwort ist falsch.'); // "Benutzername" = username, "Passwort" = password, "falsch" = wrong
                } else if (response.status === 405) {
                    throw new Error('Benutzername oder Passwort ist falsch.'); // "Benutzername" = username, "Passwort" = password, "falsch" = wrong
                    setErrorMessage('Benutzername oder Passwort ist falsch.');
                    return;
                } else {
                    throw new Error('Server ist nicht erreichbar.'); // "nicht erreichbar" = not reachable
                }
            }

            const data = await response.json();

            if (!data.token) {
                throw new Error('Kein Token vom Server erhalten'); // "Kein Token" = no token, "erhalten" = received
            }

            // Clear any session expired flag after a successful login
            try {
                localStorage.removeItem('sessionExpired');
            } catch (e) {}

            // Use our utility function to set token and reset cache
            await setAuthToken(data.token);

            // Navigate after token is properly set and cache is reset
            if (data.role === 'student') {
                window.location.href = '/student';
            } else if (data.role === 'teacher') {
                window.location.href = '/teacher';
            } else if (data.role === 'admin') {
                window.location.href = '/teacher';
            } else {
                window.location.href = '/teacher'; // fallback
            }
        } catch (error) {
            console.error('Login-Fehler:', error); // "Fehler" = error
            if (error.message === 'Benutzername oder Passwort ist falsch.') {
                setErrorMessage(error.message);
            } else {
                setErrorMessage('Server ist nicht erreichbar.'); // "Server ist nicht erreichbar" = server is not reachable
            }
        }
    }

    function handleSubmit(event) {
        event.preventDefault();
        login(username, password);
    }

    return (
        <section className="bg-neutral-800 h-screen flex flex-col">
        <div className="block md:hidden flex items-center p-4">
                <div className="text-white font-bold text-center w-full py-3">
                    <div className="">
                        <p className="uppercase text-sm"><span className="font-black">Theresianische</span>akademie</p>
                        <img src="/dots.svg" alt="dots" className="h-1 ml-1 inline-block" />
                        <p className="uppercase text-2xl"><span className="font-black">Chrono</span>school</p>
                    </div>
                </div>
            </div>
        <div className="flex flex-1">
            
            <div className="hidden md:w-2/5 lg:1/5 bg-neutral-800 md:flex items-center max-w-[500px]">
                <div className="p-8">
                    <div className="text-white text-4xl font-bold space-y-3">
                        <p className="text-2xl uppercase">
                            <span className="font-black">Theresianische</span>akademie<br />
                        </p>
                        <img src="/dots.svg" alt="dots" className="h-1.5 ml-1" />
                        <p className="text-4xl uppercase">
                            <span className="font-black">Chrono</span>school<br />
                        </p>
                    </div>
                    <p className="mt-6 text-neutral-300">
                        &copy; 2021 - {new Date().getFullYear()} <a href="https://maxim.dikov.at" target="_blank">Maxim Dikov</a><br />
                    </p>
                </div>
            </div>
            
            <div className="flex-1 flex items-center justify-center bg-neutral-200 p-8">
                <div className="w-full max-w-md md:min-w-[600px]">
                    {sessionMessage && (
                        <div className="mb-6 p-4 bg-yellow-100 text-yellow-800 border border-yellow-200 rounded">
                            {sessionMessage}
                        </div>
                    )}
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <TextInput
                            id="username"
                            labelText="Benutzername"
                            placeholder="Benutzername eingeben"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                        <TextInput
                            id="password"
                            labelText="Passwort"
                            type="password"
                            placeholder="Passwort eingeben"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <div className="flex justify-between items-center">
                            <p className="text-sm text-red-600">
                                {errorMessage}
                            </p>
                            <button type="submit" className=" md:w-full max-w-[200px] bg-neutral-600 text-white py-3 px-4 hover:bg-neutral-700 transition duration-200 text-right">
                                Anmelden
                            </button>
                        </div>
                    
                    </form>
                </div>
            </div>
        </div>
        <p className="block md:hidden text-sm text-center text-neutral-500 bg-neutral-200 py-2">
            by Maxim Dikov &copy; 2021 - {new Date().getFullYear()}
        </p>
        </section>
    );
}